export default __webpack_public_path__ + "static/media/logo.c54e1a5f.png";